import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-grid p-fluid" }
const _hoisted_2 = { class: "p-col-12 p-md-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Adı"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a card holder's name"
  })
], -1)
const _hoisted_4 = { class: "p-col-12 p-md-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Aktif")
], -1)

import { ref, withDefaults } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Field } from "vee-validate";
import Modal from "@/components/Modal.vue";
import { useToast } from "primevue/usetoast";
import Checkbox from "primevue/checkbox";
import { boolean } from "yup/lib/locale";
export interface PropsModel {
  id: number;
  isActive: boolean;
  name: string;
  active: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Update',
  props: {
    id: { default: 0 },
    isActive: { type: Boolean, default: false },
    name: { default: undefined },
    active: { type: Boolean, default: false }
  },
  emits: ["changeReceipt"],
  setup(__props: any, { emit }) {

const props = __props as { id: number, isActive: boolean, name: string, active: boolean }

const updateButtonDisabled = ref(false);


const isActive = ref(props.isActive);
const toast = useToast();

const store = useStore();
const orderTypeName = ref(props.name);
const activeData = ref(props.active);
const toggleModal = () => {
  isActive.value = !isActive.value;
};

const onChange = (args) => {
  emit("changeReceipt", args);
};
const saveChanges = () => {
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  updateButtonDisabled.value = true;
  var model = {
    id: props.id,
    name: orderTypeName.value,
    isActive: activeData.value,
  };
  store.dispatch(Actions.UPDATE_ORDERTYPE, model).then((x) => {
    if (x.success) {
      toast.add({
        severity: "success",
        summary: "İşlem Sonucu",
        detail: x.message,
        life: 3000,
      });
      store.dispatch(Actions.ORDERTYPE_LIST);
      updateButtonDisabled.value = false;
    } else {
      toast.add({
        severity: "error",
        summary: "İşlem Sonucu",
        detail: x.message,
        life: 3000,
      });
      updateButtonDisabled.value = false;
    }
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  });
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(Modal, {
    onClose: onChange,
    modalActive: props.isActive,
    title: "Sipariş Tipi Güncelle",
    width: "75vw"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Güncelle ",
        type: "button",
        ref: "updateButton",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (saveChanges())),
        icon: "pi pi-check",
        autofocus: "",
        disabled: updateButtonDisabled.value
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(Field), {
            type: "text",
            class: "form-control form-control-solid",
            placeholder: "",
            name: "orderTypeName",
            modelValue: orderTypeName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((orderTypeName).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_unref(Checkbox), {
            id: "binary",
            modelValue: activeData.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeData).value = $event)),
            binary: true
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})